var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff !important;stroke:#707070 !important;}.b{clip-path:url(#a);}.c{stroke:#fff !important;stroke-width:0.3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(1463 615)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1463 -615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.41,23.43c-3.14,0-7.11-1.89-10.53-5.31C.75,13-.94,6.63,2,3.65L5.53.16l6.78,6.78L9.6,9.68a1.18,1.18,0,0,0,0,1.65l3.07,3.07a1.18,1.18,0,0,0,1.65,0l2.74-2.71,6.78,6.78L20.35,22a5.4,5.4,0,0,1-3.94,1.43ZM5.53,3,3.45,5.07C1.34,7.18,3.1,12.51,7.3,16.7s9.52,6,11.63,3.85L21,18.47l-4-4-1.33,1.31a3.18,3.18,0,0,1-4.48,0l-3-3.03a3.18,3.18,0,0,1,0-4.48l1.3-1.33Z",
    transform: "translate(1465.941 618.34)"
  }))));
};
export default SvgPhone;